import * as localforage from "localforage";
import axios from "axios";

export const getAutocompleteApi = async (type, command) => {
  const company_id = await localforage.getItem("companyId");

  let res = await axios({
    url: `/api/v2/command/get-autocomplete`,
    method: "GET",
    params: {
      company_id,
      type,
      command,
      record: 50
    }
  });
  return res.data;
};

export const createAutocompleteApi = async (type, command) => {
  const company_id = await localforage.getItem("companyId");

  let res = await axios({
    url: `/api/v2/command/create-autocomplete`,
    method: "POST",
    data: { company_id, type, command }
  });
  return res.data;
};
